import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography, Container, Snackbar
  , Radio, RadioGroup, FormControlLabel, Checkbox, Dialog, CircularProgress } from '@mui/material';
import OtpInput from 'react-otp-input';
import logo from '../images/logo_triumph.png';
import bgFYB from '../images/bgFYB.png';
import { useSearchCustomerMutation, useGetOtpMutation, useSignUpMutation } from '../services/consumer';
import LoadingPage from './loadingPage';
const BASE_NAME = process.env.REACT_APP_BASE_NAME;

let timeOut = 120;
function SignUp() {
  const navigate = useNavigate();
  const { location } = useParams();
  const [searchCustomer, searchCustomerResult] = useSearchCustomerMutation();
  const [getOtp, otpResult] = useGetOtpMutation();
  const [signUp, signUpResult] = useSignUpMutation();
  const [alert, setAlert] = useState(false);
  const [openOtp, setOpenOtp] = useState(false);
  const [timeOutOtp, setTimeOutOtp] = useState(120);
  const [intervalId, setIntervalId] = useState(null);
  const [errorValidate, setErrorValidate] = useState({});

  const [formData, setFormData] = useState({
		phoneNumber: '',
    fullName: '',
    email: '',
    gender: '1',
    referrer: '1',
    acceptterms: 1,
    otp: '',
    location: ''
  });

  useEffect(() => {
    // const encodedString = btoa("diamond plaza");
    // console.log(encodedString);
    const decodedString = atob(location); // "Hello, React!"
    setFormData((prevData) => ({
      ...prevData,
      location: decodedString,
    }));
  }, []);

  useEffect(() => {
    return () => {
        if (intervalId) {
            clearInterval(intervalId);
        }
    };
  }, [intervalId]);

  const startInterval = () => {
      const id = setInterval(() => {
          // Your interval logic here, e.g., update a counter
          timeOut -= 1;
          setTimeOutOtp(timeOut);
          if(timeOut <= 0){
            handleCloseOtp();
          }
      }, 1000); // Run every 1000 milliseconds (1 second)
      setIntervalId(id); // Store the interval ID in state
  };
  const stopInterval = () => {
    if (intervalId) {
        clearInterval(intervalId);
        setIntervalId(null); // Reset intervalId state
    }
  };

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name == "acceptterms" ? (checked?1:0) : value,
    }));
    setErrorValidate({...errorValidate, [name]: false});
  };

  useEffect(() => {
      if(otpResult.data){
        const data = JSON.parse(otpResult.data);
        if(data.error_code == -10)
        {
          setAlert("Số điện thoại không hợp lệ, vui lòng nhập số ĐT khác!");
          setErrorValidate({...errorValidate, phoneNumber: true});
        }
        else{
          timeOut = data[0].LeftTime;
          
          setOpenOtp(true);
          startInterval();
        }
      }
    }, [otpResult]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    let validate = {...errorValidate};
    if(!formData.phoneNumber.trim() || !validatePhoneNumber(formData.phoneNumber)){
      validate.phoneNumber = true;
    }
    if(!formData.fullName.trim()){
      validate.fullName = true;
    }
    if(formData.email && !validateEmail(formData.email)){
      validate.email = true;
    }
    setErrorValidate(validate);

    if(validate.phoneNumber || validate.fullName || validate.email){
      setAlert("Vui lòng nhập thông tin yêu cầu!");
      return;
    }

    const getOtpResult = await getOtp(formData).unwrap().catch((e) => { console.log(e); });
    if (!getOtpResult) {
      setAlert("Lỗi kết nối, vui lòng thử lại!");
    }
  };

  const handleCloseOtp = () =>{
    stopInterval();
    setOpenOtp(false);
  }

  const handleChangeOtp = (value) =>{
    setFormData((prevData) => ({
      ...prevData,
      otp: value,
    }));
  }

  const confirmSignup = async () =>{
    const result = await signUp(formData).unwrap().catch((e) => { console.log(e); });
    if (!result) {
      setAlert("Lỗi kết nối, vui lòng thử lại!");
    }
  }

   useEffect(() => {
    if(signUpResult.data){
      const data = JSON.parse(signUpResult.data);
      if(data.CustomerNumber){
        // window.location.href = `${BASE_NAME}/signupresult`;
        navigate(`/signupresult`, { replace: true });
      }
      else if(data.WrongOTP){
        setAlert("Sai mã OTP, vui lòng nhập lại!");
        setFormData((prevData) => ({
          ...prevData,
          otp: ''
        }));
      }
      else{
        setAlert("Lỗi kết nối, vui lòng thử lại!");
      }
    }
  }, [signUpResult]);

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(number);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
    return emailRegex.test(email);
  };

  const handleBlurPhoneNumber = async()=>{
    const check = validatePhoneNumber(formData.phoneNumber);
    if(formData.phoneNumber && !check)
      setErrorValidate({...errorValidate, phoneNumber: true});
    else if(formData.phoneNumber && check){
      const searchResult = await searchCustomer({phoneNumber: formData.phoneNumber});
      if (!searchResult) {
        setAlert("Lỗi kết nối, vui lòng thử lại!");
      }
    }
  }

  const handleBlurEmail = async()=>{
    const check = validateEmail(formData.email);
    if(formData.email && !check)
      setErrorValidate({...errorValidate, email: true});
    else if(formData.email && check){
      const searchResult = await searchCustomer({emailAddress: formData.email});
      if (!searchResult) {
        setAlert("Lỗi kết nối, vui lòng thử lại!");
      }
    }
  }

  useEffect(() => {
    if(searchCustomerResult.data){
      const data = JSON.parse(searchCustomerResult.data);
      if(data.length > 0 && searchCustomerResult.originalArgs.emailAddress && data[0].CustomerNumber){
        setAlert("Email đã đăng ký, vui lòng nhập Email khác!");
        setErrorValidate({...errorValidate, email: true});
      }
      else if(data.length > 0 && data[0].CustomerNumber){
        setAlert("Số điện thoại đã đăng ký, vui lòng nhập số điện thoại khác!");
        setErrorValidate({...errorValidate, phoneNumber: true});
      }
    }
  }, [searchCustomerResult]);

  return (
    <Container maxWidth="sm" 
      sx={{ 
        minHeight: '100vh', 
        backgroundImage: `url(${bgFYB})`,
        backgroundSize: '100% 100%', //(e.g., ''cover', 'contain', '100% 100%')
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}
    >
      { ( otpResult.isLoading || signUpResult.isLoading) && <LoadingPage /> }
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Box component="img" src={logo} sx={{ width: 200, marginTop: 3 }} />
        <Typography component="h1" variant="h5">
          FIND YOUR BEAUTY
        </Typography>
        <Typography component="h1" variant="h6">
          Đăng ký thành viên Triumph
        </Typography>
        <Typography sx={{ textAlign: 'center' }}>
          Đăng ký để nhận ngay voucher 300.000 VND<label style={{fontWeight: 'bold'}}></label>
        </Typography>
        <Typography sx={{ textAlign: 'center' }}>
          (Áp dụng cho đơn hàng đầu tiên từ 1.500.000đ)
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            fullWidth
            id="temp"
            label="temp"
            name="temp"
            style={{display: 'none'}}
          />
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="phoneNumber"
              label="Số điện thoại"
              name="phoneNumber"
              autoFocus
              value={formData.phoneNumber}
              onChange={handleChange}
              onBlur={handleBlurPhoneNumber}
              error={errorValidate.phoneNumber}
              slotProps={{
                htmlInput: {
                  maxLength: 10
                },
                input: {
                  inputProps: {
                    inputMode: 'numeric',
                    pattern: '[0-9]*'
                  },
                  endAdornment: (
                    searchCustomerResult.isLoading && searchCustomerResult.originalArgs.phoneNumber ? <CircularProgress size={24} style={{backgroundColor: 'transparent'}} /> : ''
                  ),
                }
              }}
            />
          </Box>
					<TextField
            margin="normal"
            required
            fullWidth
            id="fullName"
            label="Họ tên"
            name="fullName"
            autoComplete="family-name"
            value={formData.fullName}
            onChange={handleChange}
            error={errorValidate.fullName}
            slotProps={{
              htmlInput: {
                maxLength: 100
              },
            }}
          />
          <TextField
            margin="normal"
            fullWidth
            type="email"
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            value={formData.email}
            onChange={handleChange}
            onBlur={handleBlurEmail}
            error={errorValidate.email}
            slotProps={{
              htmlInput: {
                maxLength: 100
              },
              input: {
                  endAdornment: (
                    searchCustomerResult.isLoading && searchCustomerResult.originalArgs.emailAddress ? <CircularProgress size={24} style={{backgroundColor: 'transparent'}} /> : ''
                  ),
                }
            }}
          />
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <label style={{padding: '8px 10px 0 0'}}>Giới tính</label>
            <RadioGroup
              aria-labelledby="gender-radio-group-label"
              id="gender"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              row // Optional: Arranges radio buttons horizontally
            >
              <FormControlLabel value="1" control={<Radio />} label="Nữ" />
              <FormControlLabel value="2" control={<Radio />} label="Nam" />
              <FormControlLabel value="3" control={<Radio />} label="Khác" />
            </RadioGroup>
          </div>
          <div style={{display: 'flex', flexDirection: 'row'}}>
            <RadioGroup
              aria-labelledby="referrer-radio-group-label"
              id="referrer"
              name="referrer"
              value={formData.referrer}
              onChange={handleChange}
              row // Optional: Arranges radio buttons horizontally
            >
              <FormControlLabel value="1" control={<Radio />} label="Biết qua truyền thông, hình ảnh, sự kiện" />
              <FormControlLabel value="2" control={<Radio />} label="Khác" />
            </RadioGroup>
          </div>
          <div>
            <FormControlLabel style={{float: 'left'}}
              control={<Checkbox checked={formData.acceptterms==1} onChange={handleChange} name="acceptterms" />}
              label=""
            />
            <div>
              <label style={{fontSize: '0.8em'}}>Tôi đồng ý nhận thông tin từ Triumph qua tất cả các kênh liên lạc gồm Zalo OA, 
                Tôi đã đọc và hiểu rõ về chính sách bảo mật của Triumph, đồng ý cho phép công ty TNHH Triumph International Việt Nam thu thập, 
                sử dụng và chuyển dữ liệu thông tin cá nhân của tôi trong hệ thống Triumph toàn cầu để phục vụ quá trình mua sắm và liên hệ các chương trình khuyến mãi.</label>
            </div>
          </div>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={searchCustomerResult.isLoading || otpResult.isLoading}
          >
            Đăng ký
          </Button>
        </Box>
      </Box>

      <Dialog onClose={handleCloseOtp} open={openOtp}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px'
            , backgroundColor: '#f5dde1' }}>
          <label style={{fontWeight: 'bold'}}>Xác thực số điện thoại</label>
          <div style={{textAlign: 'center', marginTop: '5px'}}>Quý khách vui lòng nhập mã OTP đã gửi về số điện thoại {formData.phoneNumber.substring(0, 2)}*****{formData.phoneNumber.slice(-3)}</div>
          <OtpInput
            value={formData.otp}
            onChange={handleChangeOtp}
            numInputs={4}
            renderSeparator={<span>&nbsp;</span>}
            renderInput={(props) => <input {...props} inputMode="numeric" type="tel" />}
            inputStyle={{ fontSize: '24px', marginTop: '8px', padding: '5px', borderRadius: '10px' }}
          />
          <div style={{marginTop: '5px'}}><label>Mã OTP sẽ hết hạn sau </label><label style={{color: 'red'}}>{timeOutOtp}</label></div>
          <Button
            size='large'
            variant="contained"
            sx={{ mt: 3 }}
            onClick={confirmSignup}
            disabled={signUpResult.isLoading}
          >
            Xác nhận
          </Button>
        </Box>
      </Dialog>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
        // action={action}
      />
    </Container>
  );
}

export default SignUp;